
export const CapabilityName = {   
    BackSplash : 'backsplash',
    Loader : 'loader',
    Modal: 'modal',
    Notification: 'notification',
    ReleaseNotes: 'releasenotes',
}


export const Role = {
    Novice: 'Novice',
    Intermediate: 'Intermediate',
    Advanced: 'Advanced',
    Professional: 'Professional'
}


